module.exports = __webpack_public_path__ + "static/media/header.018514cf.mp3";